import * as React from 'react';
const AcetoneNeiBambiniENegliAdultiIcon = ({
  primaryColor,
  secondaryColor,
  width,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M96.11 65.94c.37-3.54 3.51-6.11 7.02-5.74s6.05 3.54 5.68 7.08l-.5 4.81c-.37 3.54-3.51 6.11-7.02 5.74s-6.05-3.54-5.69-7.08l.5-4.81Z"
      className="prefix__cls-2"
    />
    <path
      d="M107.69 74.32c5.47 2.05 8.54 7.26 8.54 9.46v13.28c0 2.95-1.76 5.9-8.85 5.9-1.68 0-3.14 0-4.43-.03"
      className="prefix__cls-2"
    />
    <path
      d="M96.16 74.13c-6.86 1.37-12.39 4.82-12.39 9.65 0 2.95 1.48 16.23 1.48 16.23s5.16 5.9 11.8 5.9c5.16 0 5.9-.91 5.9-2.95v-.03c-.03-2.26-4.1-2.77-7.36-4.5-.96-.5-1.86-1.12-2.55-1.9 0 0-.99-2.64-1.89-9.8"
      className="prefix__cls-2"
    />
    <path
      d="M108.85 86.72v8.85c-7.92 0-13.14-.09-13.26 2.85M86.78 101.48l-1.41 35.28c-.03.8.26 1.58.82 2.16s1.32.91 2.13.91c2.49 0 4.62-1.79 5.05-4.24l3.68-20.84 4.91 20.89a5.43 5.43 0 0 0 5.29 4.19c.8 0 1.57-.33 2.13-.91s.85-1.36.82-2.16l-1.35-33.86"
      className="prefix__cls-2"
    />
    <path
      d="m116.23 107.38 5.9 5.9 2.95-4.43 5.9 5.9M79.35 107.38l-5.9 5.9-2.95-4.43-5.9 5.9M122.13 79.35l7.58-3.81-3.36-4.19 7.58-3.8M77.87 79.35l-7.58-3.81 3.36-4.19-7.58-3.8M123.6 97.05h8.85l-2.95-5.9h8.85M76.4 97.05h-8.85l2.95-5.9h-8.85"
      className="prefix__cls-1"
    />
  </svg>
);
export default AcetoneNeiBambiniENegliAdultiIcon;
